document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const listItems = document.querySelectorAll(".buckscc-select-options .converterTriggers");
    console.log("Currency script initialized");

    listItems.forEach(function (item) {
      item.addEventListener("click", function () {
        console.log("Currency clicked: ", item.id);
        setTimeout(function () {
          location.reload();
        }, 500);
      });
    });
  }, 2000); // Wait 2 seconds before attaching click listeners








document.querySelector('.cstm-interview-skip-btn')?.addEventListener('click', function() {
  document.querySelector('.btn.cstm-btn-checkout.cstm-cvd.cstm-ic')?.click();
});




  
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on the correct page
    const layout = document.querySelector('.content-for-layout');
    if (!layout) return;

    const tabs = document.querySelectorAll('.tab');
    const serviceGroups = document.querySelectorAll('.service-group');
    const pricingTiersCV = document.querySelectorAll('.cstm-cv-products .pricing-tier');
    const pricingTiersInterview = document.querySelectorAll('.cstm-interview-products .pricing-tier');
    const cartItemsContainer = document.getElementById('cart-items-container');
    const vatAmount = document.getElementById('vat-amount');
    const totalAmount = document.getElementById('total-amount');
    const checkoutButtons = document.querySelectorAll('.cstm-btn-checkout');
    const skipButton = document.querySelector('.cstm-cv-skip-btn');
    const cvBackButton = document.querySelector('.cstm-cv-back');
    const interviewBackButton = document.querySelector('.cstm-interview-back');

    let cartItems = [];
    let pendingItems = [];

    // Set currentTab dynamically
    let currentTab = tabs.length > 0 ? 
        (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).getAttribute('data-target') : 
        'graduate';

    // Inject loading spinner and cart styling CSS
    const style = document.createElement('style');
    style.textContent = `
        .loading-spinner {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            font-size: 14px;
            color: #333;
        }
        .loading-spinner::before {
            content: '';
            width: 20px;
            height: 20px;
            border: 3px solid #ccc;
            border-top: 3px solid #007bff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        .cart-experience-group {
            margin-bottom: 15px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
        }
        .cart-experience-heading {
            font-size: 16px;
            font-weight: bold;
            margin: 10px 0 5px;
            color: #333;
        }
        .cart-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 0;
        }
    `;
    document.head.appendChild(style);
    document.querySelector('.cstm-btn-checkout').addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    // Check URL for skip parameter
    const urlParams = new URLSearchParams(window.location.search);
    const skipParam = urlParams.get('skip');
    if (skipParam === 'step1') {
        checkoutButtons.forEach(btn => btn.classList.add('cstm-cvd'));
        layout.classList.add('cstm-cvd');
    } else if (skipParam === 'step2') {
      
        checkoutButtons.forEach(btn => {
            btn.classList.add('cstm-cvd', 'cstm-ic');
            btn.textContent = window.locale === 'ar' ? 'الشروع في الخروج' : 'Proceed to Checkout';
           
        });
        layout.classList.add('cstm-cvd', 'cstm-ic');
    }

    // Clear localStorage and Shopify cart on page refresh
    localStorage.removeItem('experienceCart');
    clearShopifyCart().then(() => {
        cartItems = [];
        pendingItems = [];
        updateCart();
    });

    // Function to clear Shopify cart
    async function clearShopifyCart() {
        try {
            await fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            console.error('Error clearing Shopify cart:', error);
        }
    }

    // Sync pending items with Shopify cart
    async function syncCartWithShopify() {
        try {
            await clearShopifyCart();
            for (const item of pendingItems) {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: item.variantId,
                        quantity: 1,
                        properties: item.experience ? { 'Experience Level': item.experience } : {}
                    })
                });
            }
            const response = await fetch('/cart.js');
            const cart = await response.json();
            var activeCurrency = document.querySelector('.bucks-selected').innerText;
            cartItems = cart.items.map(item => ({
                variantId: item.variant_id.toString(),
                name: item.product_title,
                price: item.price / 100,
                priceFormatted: `${activeCurrency} ${(item.price / 100).toFixed(2)}`,
                experience: item.properties['Experience Level'] || '',
                step: item.step || determineStepFromVariant(item.variant_id.toString())
            }));
            localStorage.setItem('experienceCart', JSON.stringify(cartItems));
            updateCart();
        } catch (error) {
            console.error('Error syncing with Shopify cart:', error);
            updateCart();
        }
    }

    function determineStepFromVariant(variantId) {
        const serviceItems = document.querySelectorAll('.service-item .add-to-cart-btn');
        const cvDistributionItems = document.querySelectorAll('.cstm-cv-products .pricing-tier');
        const interviewCoachingItems = document.querySelectorAll('.cstm-interview-products .pricing-tier');

        if (Array.from(serviceItems).some(btn => btn.getAttribute('data-variant-id') === variantId)) {
            return 'services';
        }
        if (Array.from(cvDistributionItems).some(tier => tier.getAttribute('data-variant-id') === variantId)) {
            return 'cv-distribution';
        }
        if (Array.from(interviewCoachingItems).some(tier => tier.getAttribute('data-variant-id') === variantId)) {
            return 'interview-coaching';
        }
        return 'unknown';
    }

    function showLoadingSpinner() {
        const spinner = document.createElement('div');
        spinner.className = 'loading-spinner';
        spinner.textContent = 'Updating cart...';
        cartItemsContainer.innerHTML = '';
        cartItemsContainer.appendChild(spinner);
    }

    function updateCart() {
        console.log('Updating cart with items:', JSON.parse(JSON.stringify(pendingItems)));
        cartItemsContainer.innerHTML = '';
        let subtotal = 0;

        // Group items by experience level or step
        const groupedItems = {};
        pendingItems.forEach(item => {
            if (item.step === 'services') {
                const experience = item.experience || 'Unknown';
                if (!groupedItems[experience]) {
                    groupedItems[experience] = [];
                }
                groupedItems[experience].push(item);
            } else {
                const group = item.step === 'cv-distribution' ? 'CV Distribution' : 
                             item.step === 'interview-coaching' ? 'Interview Coaching' : 
                             'Other Services';
                if (!groupedItems[group]) {
                    groupedItems[group] = [];
                }
                groupedItems[group].push(item);
            }
        });

        // Display items grouped by experience level
        Object.keys(groupedItems).forEach(group => {
            const groupContainer = document.createElement('div');
            groupContainer.className = 'cart-experience-group';

            const heading = document.createElement('div');
            heading.className = 'cart-experience-heading';
            heading.textContent = group;
            groupContainer.appendChild(heading);

            groupedItems[group].forEach(item => {
                const cartItemElement = document.createElement('div');
                cartItemElement.className = 'cart-item';
                cartItemElement.innerHTML = `
                    <span>${item.name}</span>
                    <span class="price money buckscc-converted buckscc-money">${item.priceFormatted}</span>
                    <button class="remove-item" data-variant-id="${item.variantId}">×</button>
                `;
                groupContainer.appendChild(cartItemElement);
                subtotal += Number(item.price); // Ensure price is treated as number
            });

            cartItemsContainer.appendChild(groupContainer);
        });

        // Calculate VAT and total - includes all steps
        const vat = subtotal * 0.05 / 1.05;
        const total = subtotal;

        var activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
        const currencySymbol = activeCurrency === 'AED' ? 'Dhs.' : activeCurrency;
        
        // Update installment display
        const installmentSpans = document.querySelectorAll('.cstm_installment');
        const totalInstallment = total/4;
        installmentSpans.forEach(span => {
          span.innerHTML = `${currencySymbol} ${totalInstallment.toFixed(1)}/month`;
        });

        // Update VAT and total display
        if (vatAmount) {
            vatAmount.textContent = `${currencySymbol} ${vat.toFixed(2)}`;
        }
        if (totalAmount) {
            totalAmount.textContent = `${currencySymbol} ${total.toFixed(2)}`;
        }

        // Add event listeners to remove buttons
        document.querySelectorAll('.remove-item').forEach(button => {
            button.addEventListener('click', function() {
                const variantId = this.getAttribute('data-variant-id');
                showLoadingSpinner();
                pendingItems = pendingItems.filter(item => item.variantId !== variantId);
                localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
                updateCart();
            });
        });
    }

    // Tab switching for experience levels
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('selected'));
            tab.classList.add('selected');

            serviceGroups.forEach(group => group.classList.remove('active'));
            const target = tab.getAttribute('data-target');
            document.getElementById(target).classList.add('active');
            currentTab = target;

            updateCart();
        });
    });

    // Add to pending items for Services (Step 1)
    document.querySelectorAll('.service-item .add-to-cart-btn').forEach(button => {
        button.addEventListener('click', function() {
            const variantId = this.getAttribute('data-variant-id');
            const productItem = this.closest('.service-item');
            const productName = productItem.querySelector('.service-left span').textContent;
            const productPrice = productItem.querySelector('.price').textContent;
            const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
            const priceValue = parseCurrencyValue(productPrice, activeCurrency);

            if (pendingItems.some(item => item.variantId === variantId)) return;

            showLoadingSpinner();

            const item = {
                variantId: variantId,
                name: productName,
                price: priceValue,
                priceFormatted: productPrice,
                experience: tabs.length > 0 ? (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).querySelector('h4').textContent : '',
                step: 'services'
            };
            pendingItems.push(item);
            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
        });
    });

    // Add to pending items for CV Distribution (Step 2)
    pricingTiersCV.forEach(tier => {
        tier.addEventListener('click', function() {
            pricingTiersCV.forEach(t => t.classList.remove('selected'));
            this.classList.add('selected');

            const variantId = this.getAttribute('data-variant-id');
            const tierNameElement = this.querySelector('.tier-name');
            const tierName = tierNameElement.textContent.split(' - ')[0];
            
            // Improved price extraction
            const priceElement = this.querySelector('.price .money') || 
                                this.querySelector('.price') || 
                                tierNameElement;
            const priceText = priceElement.textContent.trim();
            
            // Get active currency
            const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
            const currencySymbol = activeCurrency === 'AED' ? 'Dhs.' : activeCurrency;
            
            // Extract numeric value
            const priceValue = parseCurrencyValue(priceText, activeCurrency);
            const priceFormatted = `${currencySymbol} ${priceValue.toFixed(2)}`;

            showLoadingSpinner();

            // Remove any existing CV Distribution item
            pendingItems = pendingItems.filter(item => item.step !== 'cv-distribution');

            // Add new item
            const item = {
                variantId: variantId,
                name: tierName,
                price: priceValue,
                priceFormatted: priceFormatted,
                step: 'cv-distribution'
            };
            pendingItems.push(item);
            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
        });
    });

    // Add to pending items for Interview Coaching (Step 3)
    pricingTiersInterview.forEach(tier => {
        tier.addEventListener('click', function() {
            pricingTiersInterview.forEach(t => t.classList.remove('selected'));
            this.classList.add('selected');

            const variantId = this.getAttribute('data-variant-id');
            const tierNameElement = this.querySelector('.tier-name');
            const tierName = tierNameElement.textContent.split(' - ')[0];
            
            // Improved price extraction
            const priceElement = this.querySelector('.price .money') || 
                                this.querySelector('.price') || 
                                tierNameElement;
            const priceText = priceElement.textContent.trim();
            
            // Get active currency
            const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
            const currencySymbol = activeCurrency === 'AED' ? 'Dhs.' : activeCurrency;
            
            // Extract numeric value
            const priceValue = parseCurrencyValue(priceText, activeCurrency);
            const priceFormatted = `${currencySymbol} ${priceValue.toFixed(2)}`;

            showLoadingSpinner();

            // Remove any existing Interview Coaching item
            pendingItems = pendingItems.filter(item => item.step !== 'interview-coaching');

            // Add new item
            const item = {
                variantId: variantId,
                name: tierName,
                price: priceValue,
                priceFormatted: priceFormatted,
                step: 'interview-coaching'
            };
            pendingItems.push(item);
            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
        });
    });

    // Step navigation logic
    checkoutButtons.forEach(button => {
        button.addEventListener('click', async function(e) {
            if (!button.classList.contains('cstm-cvd')) {
                // Move from Step 1 to Step 2
                if (pendingItems.filter(item => item.step === 'services').length === 0) {
                    e.preventDefault();
                    alert(window.locale === 'ar' ? 'الرجاء تحديد خدمة واحدة على الأقل للمتابعة.' : 'Please select at least one service to proceed.');
                    return;
                }
                checkoutButtons.forEach(btn => btn.classList.add('cstm-cvd'));
                layout.classList.add('cstm-cvd');
                updateCart();
            } else if (button.classList.contains('cstm-cvd') && !button.classList.contains('cstm-ic')) {
                // Move from Step 2 to Step 3
                checkoutButtons.forEach(btn => {
                    btn.classList.add('cstm-ic');
                    btn.textContent = window.locale === 'ar' ? 'الشروع في الخروج' : 'Proceed to Checkout';
                });
                layout.classList.add('cstm-ic');
                updateCart();
            } else if (button.classList.contains('cstm-ic')) {
                // Final checkout
                if (pendingItems.length === 0) {
                    e.preventDefault();
                    alert(window.locale === 'ar' ? 'الرجاء تحديد خدمة واحدة على الأقل للمتابعة.' : 'Please select at least one service to proceed.');
                    return;
                }
                showLoadingSpinner();
                await syncCartWithShopify();
                window.location.href = '/checkout';
            }
        });
    });

    // Handle Skip button (Step 2 to Step 3)
    if (skipButton) {
        skipButton.addEventListener('click', function() {
            if (checkoutButtons[0].classList.contains('cstm-cvd')) {
                checkoutButtons.forEach(btn => {
                    btn.classList.add('cstm-ic');
                    btn.textContent = window.locale === 'ar' ? 'الشروع في الخروج' : 'Proceed to Checkout';
                });
                layout.classList.add('cstm-ic');
                updateCart();
            }
        });
    }

    // Handle CV Back button (Step 2 to Step 1)
    if (cvBackButton) {
        cvBackButton.addEventListener('click', function() {
            checkoutButtons.forEach(btn => {
                btn.classList.remove('cstm-cvd', 'cstm-ic');
                btn.textContent = window.locale === 'ar' ? 'انتقل إلى الخطوة التالية' : 'Proceed to Next Step';
            });
            layout.classList.remove('cstm-cvd', 'cstm-ic');
            pendingItems = pendingItems.filter(item => item.step === 'services');
            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
        });
    }

    // Handle Interview Back button (Step 3 to Step 2)
    if (interviewBackButton) {
        interviewBackButton.addEventListener('click', function() {
            checkoutButtons.forEach(btn => {
                btn.classList.remove('cstm-ic');
                btn.textContent = window.locale === 'ar' ? 'انتقل إلى الخطوة التالية' : 'Proceed to Next Step';
            });
            layout.classList.remove('cstm-ic');
            pendingItems = pendingItems.filter(item => item.step !== 'interview-coaching');
            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
        });
    }

    // Mobile scroll for experience tabs
    const experienceTabs = document.querySelectorAll('.cstm-exper-block .tabs .tab');
    experienceTabs.forEach(tab => {
        tab.addEventListener('click', function() {
            if (window.innerWidth <= 768) {
                const cartElement = document.querySelector('.cstm-experience .services');
                if (cartElement) {
                    cartElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });
    });

  // Mobile scroll for second steps tabs
    const secondStepsTabs = document.querySelectorAll('.cstm-cv-products .pricing-tier');
    secondStepsTabs.forEach(tab => {
        tab.addEventListener('click', function() {
            if (window.innerWidth <= 768) {
                const cartElementSecondStep = document.querySelector('.cart');
                if (cartElementSecondStep) {
                    cartElementSecondStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });
    });

    // Replace all price parsing logic with this universal function
    function parseCurrencyValue(priceText, currencyCode) {
    console.log('Input priceText:', priceText, 'Currency:', currencyCode); // Debug log

    // Step 1: Remove currency prefix (Dhs.) and any whitespace
    let normalizedText = priceText.replace(/^Dhs\.\s*/i, '').trim();
    console.log('After removing Dhs. and whitespace:', normalizedText); // Debug log

    // Step 2: Remove any remaining non-numeric characters except digits, commas, and dots
    normalizedText = normalizedText.replace(/[^\d,.]/g, '');
    console.log('After removing non-numeric:', normalizedText); // Debug log

    if (currencyCode === 'AED') {
        // For AED (e.g., 1,065.03), treat comma as thousand separator and dot as decimal
        normalizedText = normalizedText.replace(/,/g, '');
        console.log('After AED comma removal:', normalizedText); // Debug log
    } else {
        // Determine if it's a European format (e.g., 1.234,56) or international (e.g., 1,234.56)
        const hasCommaDecimal = /,\d{2}$/.test(normalizedText); // Ends with , and two digits
        const hasDotDecimal = /\.\d{2}$/.test(normalizedText); // Ends with . and two digits

        if (hasCommaDecimal) {
            // European format: replace dots with nothing, comma with dot
            normalizedText = normalizedText.replace(/\./g, '').replace(',', '.');
            console.log('After European format handling:', normalizedText); // Debug log
        } else if (hasDotDecimal) {
            // International format: remove commas
            normalizedText = normalizedText.replace(/,/g, '');
            console.log('After international format handling:', normalizedText); // Debug log
        } else {
            // Fallback: keep only the last separator as decimal
            const lastSeparator = Math.max(
                normalizedText.lastIndexOf(','),
                normalizedText.lastIndexOf('.')
            );
            if (lastSeparator > -1) {
                normalizedText =
                    normalizedText.substring(0, lastSeparator).replace(/[.,]/g, '') +
                    normalizedText.substring(lastSeparator).replace(',', '.');
            } else {
                normalizedText = normalizedText.replace(/[.,]/g, '');
            }
            console.log('After fallback handling:', normalizedText); // Debug log
        }
    }

    const parsedValue = parseFloat(normalizedText);
    console.log('Parsed Value:', parsedValue); // Debug log
    return isNaN(parsedValue) ? 0 : parsedValue;
}

    function updateIconsAndScroll(targetClass) {
        document.querySelector('.ic-essencial')?.classList.remove('selected-show');
        document.querySelector('.ic-pro')?.classList.remove('selected-show');
        document.querySelector('.ic-executive')?.classList.remove('selected-show');

        if (targetClass === 'tier-essencial') {
            document.querySelector('.ic-essencial')?.classList.add('selected-show');
            document.querySelector('.ic-essencial')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (targetClass === 'tier-pro-edge') {
            document.querySelector('.ic-pro')?.classList.add('selected-show');
            document.querySelector('.ic-pro')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (targetClass === 'tier-executive') {
            document.querySelector('.ic-executive')?.classList.add('selected-show');
            document.querySelector('.ic-executive')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    document.querySelectorAll('.tier-essencial, .tier-pro-edge, .tier-executive').forEach(el => {
        el.addEventListener('click', () => {
            document.querySelectorAll('.tier-essencial, .tier-pro-edge, .tier-executive')
                .forEach(t => t.classList.remove('selected'));
            el.classList.add('selected');
            updateIconsAndScroll(el.classList.contains('tier-essencial') ? 'tier-essencial' :
                                el.classList.contains('tier-pro-edge') ? 'tier-pro-edge' :
                                'tier-executive');
        });
    });
});